import { t as uiText } from '../../i18n';

export const DYNAMIC_EMBED_SRC = 'https://notreu.com/widget/embed.js';

/** フローティングウィジェット設定の動的タイプ（直埋め込み）と同じコード。 */
export function buildDynamicEmbedCode(params: { token: string; publishId: string }): string {
  if (!params.token) return '';
  return uiText("<!-- Preconnect to the API endpoint (faster load) -->\n<link rel=\"preconnect\" href=\"https://notreu.com\">\n<link rel=\"dns-prefetch\" href=\"https://notreu.com\">\n\n<script\n  src=\"{{embedSrc}}\"\n  data-api-token=\"{{token}}\"\n  data-publish-id=\"{{publishId}}\"\n  defer\n></script>", {
    embedSrc: DYNAMIC_EMBED_SRC,
    token: params.token,
    publishId: params.publishId,
  });
}

/** フローティングウィジェット設定の動的タイプ（GTM推奨）と同じコード。 */
export function buildDynamicEmbedCodeGtm(params: { token: string; publishId: string }): string {
  if (!params.token) return '';
  const token = params.token.replace(/'/g, "\\'");
  const publishId = params.publishId.replace(/'/g, "\\'");
  return `<!-- notreu widget (GTM: dynamic settings) -->
<script>
  (function () {
    if (document.getElementById('notreu-widget-gtm-loader')) return;
    var loader = document.createElement('span');
    loader.id = 'notreu-widget-gtm-loader';
    loader.style.display = 'none';
    document.documentElement.appendChild(loader);
    var s = document.createElement('script');
    s.src = '${DYNAMIC_EMBED_SRC}';
    s.async = true;
    s.setAttribute('data-api-token', '${token}');
    s.setAttribute('data-publish-id', '${publishId}');
    document.head.appendChild(s);
  })();
</script>`;
}
